import { type MessageInstance } from "antd/es/message/interface";

import { privateAPI } from "../../../_config/constants";
import { errorHandler } from "../../_utils";
import { type OnboardingStepsFormType, store } from "..";
import {
  setOnboardingSteps,
  setOnboardingStepsLoading,
} from "../slices/onboardingStepsSlice";

export const getOnboardingSteps = async (notify: MessageInstance) => {
  try {
    store.dispatch(setOnboardingStepsLoading(true));
    const response = await privateAPI.get("/onboarding/steps/admin");
    if (response) {
      store.dispatch(setOnboardingStepsLoading(false));
      store.dispatch(setOnboardingSteps(response.data));
    }
    return response;
  } catch (error) {
    store.dispatch(setOnboardingStepsLoading(false));
    console.error("Get Onboarding Steps Error:", error);
    errorHandler(error, notify);
  }
};

export const createOnboardingStep = async (
  notify: MessageInstance,
  payload: OnboardingStepsFormType,
) => {
  try {
    store.dispatch(setOnboardingStepsLoading(true));
    const { data } = await privateAPI.post("/onboarding/steps", payload);
    notify.success("Onboarding step created successfully!");
    return data;
  } catch (error) {
    console.error("Create Onboarding Step Error:", error);
    errorHandler(error, notify);
  } finally {
    store.dispatch(setOnboardingStepsLoading(false));
  }
};

export const updateOnboardingSteps = async (
  notify: MessageInstance,
  payload: OnboardingStepsFormType,
) => {
  try {
    if (!payload.id) return;
    store.dispatch(setOnboardingStepsLoading(true));
    const { data } = await privateAPI.patch(
      `/onboarding/steps/${payload.id}`,
      payload,
    );
    notify.success("Onboarding Step updated successfully!");
    return data;
  } catch (error) {
    console.error("Update Onboarding Step Error:", error);
    errorHandler(error, notify);
  } finally {
    store.dispatch(setOnboardingStepsLoading(false));
  }
};

export const deleteOnboardingStep = async (
  notify: MessageInstance,
  id: string,
  getData = false,
) => {
  try {
    store.dispatch(setOnboardingStepsLoading(true));
    const response = await privateAPI.delete(`/onboarding/steps/${id}`);
    if (response) {
      getData && (await getOnboardingSteps(notify));
    }
    notify.success("Onboarding Step deleted successfully!");
    return response;
  } catch (error) {
    console.error("Delete Onboarding Step Error:", error);
    errorHandler(error, notify);
  } finally {
    store.dispatch(setOnboardingStepsLoading(false));
  }
};
